import axios from "axios";
import { GENERAL_URL_API } from "../../../urls";

export const eliminarSedeClassics = async (nombreSede) => {
  const fd = new FormData();
  fd.append("nombreSede", nombreSede);

  const { data } = await axios.post(
    `${GENERAL_URL_API}/app/eliminarSedes`,
    fd,
    {
      withCredentials: true,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return data;
};
